var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._g(_vm._b({}, "div", _vm.$attrs, false), _vm.$listeners),
    [
      _vm.isCalendarHoliday
        ? _c("calendar-holiday-legend", {
            attrs: { description: _vm.employeeData.calendarHolidayDescription },
          })
        : _c("div", [_vm._v(" ")]),
      _c(
        "div",
        {
          staticClass: "p-2",
          on: {
            click: function ($event) {
              $event.stopPropagation()
              return _vm.dayItemClicked.apply(null, arguments)
            },
          },
        },
        [
          _vm.isAbsenceJustified
            ? _c("absence-justified-day-legend", {
                attrs: { withTitle: false },
              })
            : _vm.isAbsenceUnjustified
            ? _c("absence-unjustified-day-legend", {
                attrs: { withTitle: false },
              })
            : _vm.isAbsenceConfirmWaiting
            ? _c("absence-confirm-waiting-day-legend", {
                attrs: { withTitle: false },
              })
            : _vm.isVacationsNeedReunion
            ? _c("vacations-need-meeting-day-legend", {
                attrs: { withTitle: false },
              })
            : _vm.isVacationsConfirmWaiting
            ? _c("vacation-confirm-waiting-day-legend", {
                attrs: { withTitle: false },
              })
            : _vm.isVacationsApproved
            ? _c("vacations-approved-day-legend", {
                attrs: { withTitle: false },
              })
            : _vm.isDayOff
            ? _c("off-day-legend", { attrs: { withTitle: false } })
            : _vm.isDaySick
            ? _c("sick-day-legend", { attrs: { withTitle: false } })
            : _vm.isWorking
            ? _c("working-day-legend", {
                attrs: {
                  withTitle: false,
                  badge: _vm.approvedHour,
                  workShiftCode: _vm.employeeData.workShiftCode,
                  workShiftName: _vm.employeeData.workShiftDescription,
                  date: _vm.employeeData.date,
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "mt-2" },
        [
          _c("workshift-legend", {
            attrs: {
              date: _vm.employeeData.date,
              workShiftCode: _vm.employeeData.workShiftCode,
              workShiftDescription: _vm.employeeData.workShiftDescription,
            },
          }),
        ],
        1
      ),
      _c("div", { staticClass: "row no-gutters mb-1 mt-2" }, [
        _c(
          "div",
          { staticClass: "col-6" },
          [
            _vm.employeeData.overtimeDay
              ? _c("overtime-day-legend", {
                  attrs: {
                    withTitle: false,
                    badge: _vm.employeeData.overtimeDay.qtyExtra,
                    overtime: _vm.employeeData.overtimeDay,
                  },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.overtimeItemClicked(
                        _vm.employeeData.overtimeDay
                      )
                    },
                  },
                })
              : _vm._e(),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-6" },
          [
            _vm.employeeData.overtimeNight
              ? _c("overtime-night-legend", {
                  attrs: {
                    withTitle: false,
                    badge: _vm.employeeData.overtimeNight.qtyExtra,
                    overtime: _vm.employeeData.overtimeNight,
                  },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.overtimeItemClicked(
                        _vm.employeeData.overtimeNight
                      )
                    },
                  },
                })
              : _vm._e(),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }